import _ from 'underscore';

import { TopChangesFilterOption } from '@bingads-webui-campaign/overview-cards-common';

const defaultSelectedMetric = 'Clicks';

export const getTopChangesAllMetrics = i18n => ([{
  key: 'Clicks',
  displayName: i18n.getString(_TL_('Clicks')),
}, {
  key: 'Impressions',
  displayName: i18n.getString(_TL_('Impressions')),
}, {
  key: 'CTR',
  displayName: i18n.getString(_TL_('CTR')),
}, {
  key: 'Spend',
  displayName: i18n.getString(_TL_('Spend')),
}, {
  key: 'AverageCPC',
  displayName: i18n.getString(_TL_('Avg. CPC')),
}, {
  key: 'PartialConversionCPA',
  displayName: i18n.getString(_TL_('Conv.')),
}, {
  key: 'PartialConversionRate',
  displayName: i18n.getString(_TL_('Conv. Rate')),
}]);

export function getPropsForTopChanges({
  navigationLevel,
  cardPreference,
  patchPreference,
  i18n,
  campaignType,
}) {
  const allMetrics = getTopChangesAllMetrics(i18n);
  let preferenceFromServer = _.get(cardPreference, 'metric');
  if (!_.isString(preferenceFromServer)
    || !allMetrics.some(metric => metric.key === preferenceFromServer)
  ) {
    preferenceFromServer = defaultSelectedMetric;
  }

  return {
    preferenceFromServer,
    patchPreference,
    navigationLevel,
    campaignType,
  };
}

export const getHeaderPropsFromPreferenceForTopChanges = ({
  cardPreference,
  patchPreference,
  i18n,
}) => ({
  options: [
    {
      value: TopChangesFilterOption.AllChanges,
      displayName: i18n.getString(_TL_('All changes')),
    },
    {
      value: TopChangesFilterOption.TopGainers,
      displayName: i18n.getString(_TL_('Top gainers')),
    },
    {
      value: TopChangesFilterOption.TopDecliners,
      displayName: i18n.getString(_TL_('Top decliners')),
    },
    {
      value: TopChangesFilterOption.Insights,
      displayName: i18n.getString(_TL_('Insights')),
    },
  ],
  initialSelectedValue: (cardPreference && cardPreference.filter) || TopChangesFilterOption.AllChanges,
  onOptionSelected: (value) => {
    patchPreference({
      filter: value,
    });
  },
});

export const getDfmPreferenceObjectForTopChanges = cardPreference => ({
  metric: cardPreference.metric,
  selectedMenuItem: cardPreference.filter,
});

export const getDefaultTopChangesPreference = () => ({
  filter: TopChangesFilterOption.AllChanges,
  metric: defaultSelectedMetric,
});
